import { CaseStatus } from "@/store/clientApi";

// Roles / Permissions
export const UserManagementPermissions = ["read:members"];

// Pagination
export const perPageAmounts = [25, 5, 10, 50];

// Case constants
export const INCOMPLETE_CASE_STATUSES: CaseStatus[] = ["pending_upload", "uploaded", "files_converted", "preprocessed", "failed"];
export const COMPLETE_CASE_STATUSES: CaseStatus[] = ["done", "downloaded", "rejected"];
export const NOT_DOWNLOADABLE_CASE_STATUES: CaseStatus[] = ["pending_upload", "uploaded", "unpaid_upload"];
